import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Add, Call } from '@mui/icons-material';
import { Box, Button, IconButton, InputAdornment, Link, Typography } from '@mui/material';
import { useCallbacks } from 'shared/hooks/utils';
import { useCallback, useContext, useState } from 'react';
import { PhoneNumberField } from 'console/shared/components/fields/phone-number';
import { Z3KSettings } from 'console/device-settings/z3k/provider/types';
import { ControlWithoutValidation } from 'console/shared/components/fields/control/without-validation';
import { TextInputWrapper } from 'console/shared/components/fields/text';
import { useBooleanState } from 'shared/hooks/state/boolean';
export const AddRepaimanMaintenance = ({ specialistsList, setToogleMenu, setSpecialistsList, }) => {
    const { save_device_settings } = useContext(Z3KSettings);
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [error, setError] = useState(false);
    const [specialist_changed, , changed] = useBooleanState(false);
    const [phone_changed, , Phonechanged] = useBooleanState(false);
    const onChangeName = useCallbacks([setName, changed]);
    const onChangePhone = useCallbacks([setPhone, Phonechanged]);
    const updateSpecialist = () => {
        if (specialistsList && specialistsList?.length <= 2) {
            const newSpecialist = [...specialistsList, { name: name, phone: phone }];
            setSpecialistsList(newSpecialist);
            save_device_settings({ specialists: newSpecialist });
            setToogleMenu;
        }
        else {
            setError(true);
            setTimeout(() => {
                setError(false);
            }, 2500);
        }
    };
    const phone_field = useCallback((input_props) => (_jsx(PhoneNumberField, { ...input_props, InputProps: {
            endAdornment: (_jsx(InputAdornment, { position: "end", children: _jsx(IconButton, { component: Link, href: 'tel:+' + phone, disabled: phone === '', size: "large", children: _jsx(Call, {}) }) })),
        } })), [phone]);
    return (_jsxs(Box, { display: "flex", flexDirection: "column", gap: 2, children: [_jsxs(Box, { children: [_jsx(ControlWithoutValidation, { label: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438/\u0424\u0418\u041E \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u0438\u0441\u0442\u0430", value: name, onChange: onChangeName, field: TextInputWrapper }), _jsx(ControlWithoutValidation, { label: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D", value: phone, onChange: onChangePhone, field: phone_field })] }), error && (_jsx(Typography, { color: "error.main", children: "\u0412\u0432\u0435\u0434\u0435\u043D\u043E \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0435 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043D\u043E\u043C\u0435\u0440\u043E\u0432" })), _jsx(Button, { variant: "outlined", color: "primary", onClick: updateSpecialist, disabled: !(specialist_changed && phone_changed), startIcon: _jsx(Add, {}), children: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C" })] }));
};
